const Credential = () => {
    return (
        <div className="container-fluid main-content">
            <article className="about mt-4">
                <h1>Credentials & Education History</h1>
                <p className="lead">Industry Certifications</p>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">From</th>
                        <th scope="col">Credentials</th>
                        <th scope="col">Verify</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">2021</th>
                            <td>
                                <span className="fw-bold">AWS Certified Solutions Architect – Associate</span>
                                <span className="fst-italic">
                                    <br />Amazon Web Services (AWS)
                                </span>
                            </td>
                            <td>
                            <a href="https://www.credly.com/badges/ea3c8f4e-11ca-4704-aab9-f2ffa0e5f1a1/public_url" target="_blank" rel="noreferrer">
                                <img src="/images/badges/awssaa.png" className="img-fluid" style={{ maxHeight: "5em" }} alt="AWS SAA" />
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2022</th>
                            <td>
                                <span className="fw-bold">Microsoft Certified: Azure Fundamentals</span>
                                <span className="fst-italic">
                                    <br />Microsoft
                                </span>
                            </td>
                            <td>
                            <a href="https://www.credly.com/badges/3c3a4a4a-c998-4d2a-b635-c75aa29103a9/public_url" target="_blank" rel="noreferrer">
                                <img src="/images/badges/azure.png" className="img-fluid" style={{ maxHeight: "5em" }} alt="Azure Fundamentals" />
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2023</th>
                            <td>
                                <span className="fw-bold">Certified Information Systems Security Professional (CISSP)</span>
                                <span className="fst-italic">
                                    <br />(ISC)²
                                </span>
                            </td>
                            <td>
                            <a href="https://www.credly.com/badges/794e9ac3-88d7-4ae2-8c40-79e143e22bc8/public_url" target="_blank" rel="noreferrer">
                                <img src="/images/badges/cissp.png" className="img-fluid" style={{ maxHeight: "5em" }} alt="CISSP" />
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2021</th>
                            <td>
                                <span className="fw-bold">Certified Secure Software Lifecycle Professional (CSSLP)</span>
                                <span className="fst-italic">
                                    <br />(ISC)²
                                </span>
                            </td>
                            <td>
                            <a href="https://www.credly.com/badges/9634aeea-2743-4ac8-810e-8ab287e360a5/public_url" target="_blank" rel="noreferrer">
                                <img src="/images/badges/csslp.png" className="img-fluid" style={{ maxHeight: "5em" }} alt="CSSLP" />
                            </a>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"></th>
                            <td>
                                <span className="fw-bold">Professional Certificate in Basic Artificial Intelligence</span>
                                <span className="fst-italic">
                                    <br />National University of Singapore
                                </span>
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2018</th>
                            <td>
                                <span className="fw-bold">Certified IT Business Continuity Manager (Associate)</span>
                                <span className="fst-italic">
                                    <br />Singapore Computer Society
                                </span>
                            </td>
                            <td>
                            <a href="https://www.scs.org.sg/certifications/verify?id=ac2480da-84b9-4c88-b1d4-5dc85d40f81f&display_order=badge" target="_blank" rel="noreferrer">
                                <img src="/images/badges/citbcm.png" className="img-fluid" style={{ maxHeight: "5em" }} alt="CITBCM" />
                            </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
                <p className="lead">Past Certifications</p>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Years</th>
                        <th scope="col">Credentials</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">2025</th>
                            <td>
                                <span className="fw-bold">AI4I® – Foundations in AI</span>
                                <span className="fst-italic">
                                    <br />AI Singapore
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2019 / 2021</th>
                            <td>
                                <span className="fw-bold">Enterprise Administration Professional 19-001</span><br />
                                <span className="fw-bold">ArcGIS API for JavaScript 19-001</span>
                                <span className="fst-italic">
                                    <br />Esri
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2020 - 2023</th>
                            <td>
                                <span className="fw-bold">Certified Mobile Web Specialist</span>
                                <span className="fst-italic">
                                    <br />Google for Developers
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2019 - 2024</th>
                            <td>
                                <span className="fw-bold">Computer Hacking Forensic Investigator (CHFI)</span>
                                <span className="fst-italic">
                                    <br />EC-Council
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2017 - 2023</th>
                            <td>
                                <span className="fw-bold">Certified Ethical Hacker (CEH)</span>
                                <span className="fst-italic">
                                    <br />EC-Council
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
                <p className="lead">Educational History</p>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Years</th>
                        <th scope="col">Qualifications</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">2023 - 2025</th>
                            <td>
                                <span className="fw-bold">Master of Computing (Info-Comm Security)</span>
                                <span className="fst-italic">
                                    <br />National University of Singapore (NUS)
                                </span>
                                <br />Cumulative CAP: 4.35/5.0 · CSA-National Cybersecurity R&amp;D Laboratory Scholarship
                                <br />Highlights: Cloud Computing, Big Data Systems, Software/System Security, Blockchain, Cryptography
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2018 - 2022</th>
                            <td>
                                <span className="fw-bold">Bachelor of Technology (Hons.) in Cybersecurity</span>
                                <span className="fst-italic">
                                    <br />National University of Singapore (NUS)
                                </span>
                                <br />With Honours (Highest Distinction), Cumulative CAP: 4.75/5.0 · Lee Kuan Yew Gold Medal for Best Graduate
                                <br />Highlights: Computing, Networking, Databases, Algorithms, Application Security
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className="lead">Professional Certificates &amp; Diplomas</p>
                <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Years</th>
                        <th scope="col">Qualifications</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">2025</th>
                            <td>
                                <span className="fw-bold">Certificate (Post-Diploma) in Fundamentals of Data Science</span>
                                <span className="fst-italic">
                                    <br />Singapore Polytechnic
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">2021 - 2022</th>
                            <td>
                                <span className="fw-bold">Specialist Diploma in Full Stack Web Development</span>
                                <span className="fst-italic">
                                    <br />Singapore Polytechnic
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="my-2 text-center seperator">
                    &bull; &bull; &bull;
                </div>
            </article>
        </div>
    );
};

export default Credential;
